import React, { useMemo } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import {   useCreateRouteMutation, } from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {  IRoutes } from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const torontoCities = [
  "Ajax",
  "Annex",
  "Brampton",
  "Burlington",
  "Chinatown",
  "Distillery District",
  "Downtown",
  "East York",
  "Forest Hill",
  "Greektown",
  "Harbourfront",
  "High Park",
  "Kensington Market",
  "King West",
  "Leaside",
  "Liberty Village",
  "Little Italy",
  "Markham",
  "Mississauga",
  "North York",
  "Oakville",
  "Oshawa",
  "Pickering",
  "Queen West",
  "Richmond Hill",
  "Rosedale",
  "Scarborough",
  "The Beaches",
  "Vaughan",
  "Whitby",
  "York"
];

interface ITaxpopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IRoutes;
}

const Routes = ({ openModel = false, handleCloseDialog, data }: ITaxpopup) => {
  const classes = useStyles();
  const open = openModel;
  const [newCoursing, { isLoading }] = useCreateRouteMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  const [availableCities, setAvailableCities] = React.useState<string[]>(torontoCities);
  const [selectedCities, setSelectedCities] = React.useState<string[]>([]);
  const handleClose = () => {
    handleCloseDialog(false);
  };

 
  
  const addCity = (city: string) => {
    setSelectedCities([...selectedCities, city]);
    setAvailableCities(availableCities.filter((c) => c !== city));
  };
  
  const removeCity = (city: string) => {
    setAvailableCities([...availableCities, city]);
    setSelectedCities(selectedCities.filter((c) => c !== city));
  };

React.useEffect(() => {
  if (data) {

    // Parse cities
    const cities =
      typeof data.cities === "string"
        ? JSON.parse(data.cities)
        : data.cities || [];

    setSelectedCities(cities);

    setAvailableCities(
      torontoCities.filter((city) => !cities.includes(city))
    );

    // Parse delivery schedule
    const schedule =
      typeof data.delivery_schedule === "string"
        ? JSON.parse(data.delivery_schedule)
        : data.delivery_schedule || {};

    formik.setFieldValue("deliverySchedule", {
      Monday: schedule.Monday || "",
      Tuesday: schedule.Tuesday || "",
      Wednesday: schedule.Wednesday || "",
      Thursday: schedule.Thursday || "",
      Friday: schedule.Friday || "",
    });
  }
}, [data]);

  const formik = useFormik({
    initialValues: {
      id: data?.id,
      name: data?.name,
          selectedCities:
      typeof data?.cities === "string"
        ? JSON.parse(data.cities)
        : Array.isArray(data?.cities)
        ? data?.cities
        : [],

    deliverySchedule:
      typeof data?.delivery_schedule === "string"
        ? JSON.parse(data.delivery_schedule)
        : data?.delivery_schedule || {
            Monday: "",
            Tuesday: "",
            Wednesday: "",
            Thursday: "",
            Friday: "",
          },
  },
enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const temData = {
          id: values?.id,
          name: values.name,
          cities: selectedCities,
          deliverySchedule: values.deliverySchedule,
         
        };
        if (!data) {
          delete values.id;
        }

        const addCompanyResponse = await newCoursing(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          handleClose();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

const formValid = useMemo(() => {
  const selectedCities = formik.values.selectedCities as string[]; // cast to string[]
  return formik.values.name === "" ||
    formik.values.name === undefined 
    // ||
    // !selectedCities ||
    // selectedCities.length === 0
    ? false
    : true;
}, [formik]);

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Edit Route
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={9} md={9} sm={12} xs={12}>
            <form onSubmit={formik.handleSubmit}>
             <Grid container>
                           <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Card className={classes.card}>
                               <Grid
                                 container
                                 justifyContent={"space-between"}
                                 spacing={5}
                                 sx={{ borderBottom: 2, padding: 2 }}
                                 className={classes.titleGrid}
                               >
                                 <Grid
                                   item
                                   lg={12}
                                   md={12}
                                   sm={12}
                                   xs={12}
                                   pt={2}
                                   alignContent={"center"}
                                 >
                                   <Typography className={classes.cardTitle}>
                                     Route
                                   </Typography>
                                 </Grid>
                               </Grid>
             
                               <Grid container spacing={3} p={"24px"}>
                                 <Grid item lg={12} md={12} sm={12} xs={12}>
                                   <Grid container alignItems="center">
                                     <Grid item lg={12} md={12} sm={12} xs={12}>
                                       <Typography variant="subtitle1">Name <span style={{ color: "red" }}>*</span></Typography>
                                     </Grid>
                                     <Grid item lg={12} md={12} sm={12} xs={12}>
                                       <TextField
                                         placeholder="Enter Name"
                                         size="small"
                                         {...formik.getFieldProps("name")}
                                         className={classes.textField}
                                         InputProps={{
                                           sx: {
                                             fontSize: 14,
                                           },
                                         }}
                                         InputLabelProps={{
                                           sx: {
                                             fontSize: 14,
                                           },
                                         }}
                                       />
                                     </Grid>
                                   </Grid>
                                 </Grid>
             
                                 
                                 <Grid item lg={6} md={6} sm={12} xs={12}>
                                   <Grid container alignItems="center">
                                     <Grid item lg={12} md={12} sm={12} xs={12}>
                                       <Typography variant="subtitle1">Available Cities</Typography>
                                     </Grid>
                                     <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Box sx={{ border: '1px solid #ccc', padding: 2, height: 380, overflowY: 'auto' }}>
               {availableCities.map((city) => (
                 <Box
                   key={city}
                   sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}
                 >
                   <Typography>{city}</Typography>
             
                   <Button
                     size="small"
                     variant="outlined"
                     onClick={() => addCity(city)}
                       sx={{
                 minWidth: 50,    // makes the button narrower
                 padding: '4px 8px', // less padding
                
               }}
                   >
                     <ArrowForwardIcon  sx={{ fontSize: 17 }}/>
                   </Button>
                 </Box>
               ))}
             </Box>
                                     </Grid>
                                   </Grid>
                                 </Grid>
             
                              
             
                                 <Grid item lg={6} md={6} sm={12} xs={12}>
                                   <Grid container alignItems="center">
                                     <Grid item lg={12} md={12} sm={12} xs={12}>
                                       <Typography variant="subtitle1">Selected Cities </Typography>
                                     </Grid>
                                     <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <Box sx={{ border: '1px solid #ccc', padding: 2, height: 380, overflowY: 'auto' }}>
               {selectedCities.map((city) => (
                 <Box
                   key={city}
                   sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}
                 >
                   <Typography>{city}</Typography>
             
                   <Button
                     size="small"
                     color="error"
                     variant="outlined"
                     onClick={() => removeCity(city)}
                      sx={{
                 minWidth: 50,    // makes the button narrower
                 padding: '4px 8px', // less padding
               }}
                   >
                     <RefreshIcon sx={{ fontSize: 17 }}/>
                   </Button>
                 </Box>
               ))}
             </Box>
                                     </Grid>
                                   </Grid>
                                 </Grid>
             
             
              
                               
                               </Grid>
                             </Card>
                           </Grid>
             
                            <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                                                   <Card className={classes.card}>
                                                     <Grid
                                                       container
                                                       justifyContent={"space-between"}
                                                       spacing={5}
                                                       sx={{ borderBottom: 2, padding: 2 }}
                                                       className={classes.titleGrid}
                                                     >
                                                       <Grid
                                                         item
                                                         lg={12}
                                                         md={12}
                                                         sm={12}
                                                         xs={12}
                                                         pt={2}
                                                         alignContent={"center"}
                                                       >
                                                         <Typography className={classes.cardTitle}>
                                                         Delivery Schedule
                                                         </Typography>
                                                       </Grid>
                                                     </Grid>
                                 
                                                     <Grid container spacing={3} p={"24px"}>
                                                     
                                 
                                                       {/* <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                         <Grid container alignItems="center"> */}
                                                            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
                   <Grid item xs={6} sm={4} md={2.4} key={day}>
                     <Typography variant="caption">{day}</Typography>
                     <TextField
                       type="time"
                       size="small"
                       fullWidth
                       InputLabelProps={{ shrink: true }}
                       value={formik.values.deliverySchedule[day as keyof typeof formik.values.deliverySchedule]}
                       onChange={(e) => formik.setFieldValue(`deliverySchedule.${day}`, e.target.value)}
                     />
                   </Grid>
                 ))}
                                                         {/* </Grid>
                                                       </Grid> */}
                                 
                                                       
                                                
                                                      
                                                     </Grid>
                                                   </Card>
                                                 </Grid>
             
                           <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                             <Card className={classes.card}>
                               <Grid container spacing={3} p={"24px"}>
                                 <Grid
                                   item
                                   lg={12}
                                   md={12}
                                   sm={12}
                                   xs={12}
                                   sx={{ display: "flex", justifyContent: "flex-end" }}
                                 >
                                   <Button
                                     variant="outlined"
                                     startIcon={<CloseIcon />}
                                     className={classes.addButton}
                                     //onClick={() => formik.resetForm()}
                                     onClick={handleClose}
                                   >
                                     Cancel
                                   </Button>
                                   <Box m={0.5}></Box>
             
                                   <Button
                                     variant="contained"
                                     startIcon={<SaveAltIcon />}
                                     className={classes.addButton}
                                     onClick={() => formik.handleSubmit()}
                                     disabled={!formValid || isLoading}
                                   >
                                     Save
                                   </Button>
                                 </Grid>
                               </Grid>
                             </Card>
                           </Grid>
                         </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Routes;
